import React from 'react';

import Icon, { IconType } from '@/components/Icon';
import { Locale, LOCALE_LINKS, useLocale } from '@/helpers/LangHelper';
import { FooterMatrix } from '@/helpers/NavHelper';

import styles from '../mobileNavigation.module.scss';

interface Props {
  navigationItems: FooterMatrix[];
}

export const MobileNavigationFooter: React.FC<Props> = (props: Props) => {
  const { navigationItems = [[], []] } = props;
  const { locale } = useLocale();

  return (
    <div className={styles.mobileNavigationFooterContainer}>
      <div className={styles.footerNavigationItemsContainer}>
        {Object.values(navigationItems[1])
          ?.map(Object.values)
          .flat()
          .map((item) => {
            return (
              <div key={item.id} className={styles.footerNavigationItem}>
                {item.link ? (
                  <a href={item.link}>
                    <h2>{item.name}</h2>
                  </a>
                ) : (
                  item.name
                )}
              </div>
            );
          })}
      </div>
      <div className={styles.footerInformationContainer}>
        <div className={styles.footerLogo}>
          <a href={LOCALE_LINKS[locale]?.home} target="_self" className={styles.logoAfterPay}>
            {locale === Locale.GreatBritain ? (
              <Icon type={IconType.LogoClearpay} />
            ) : (
              <Icon type={IconType.LogoAfterPay} />
            )}
          </a>
        </div>
        <div className={styles.footerServiceContent}>
          <p dangerouslySetInnerHTML={{ __html: LOCALE_LINKS[locale]?.legal.line1 || '' }}></p>
          <br />
          <p dangerouslySetInnerHTML={{ __html: LOCALE_LINKS[locale]?.legal.line2 || '' }}></p>
        </div>
      </div>
    </div>
  );
};
